exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".github-img{cursor:pointer;position:relative;top:5px;margin:0 8px 0 5px}", ""]);

// exports
